import { createReducer, on } from '@ngrx/store';
import { TestCaseGeneratorActions } from '../actions/testcase-generator.actions';
import {
  initialState,
  jiraAdapter,
  testCaseAdapter,
  testCaseByVersionIdAdapter,
  testCaseVersionAdapter,
} from '../states/testcase-generator.state';

export const testcaseGeneratorReducer = createReducer(
  initialState,
  // JIRA Stories
  on(TestCaseGeneratorActions.loadJiraStories, (state) => ({
    ...state,
    jiraStories: jiraAdapter.removeAll(state.jiraStories),
    loading: true,
    error: null,
  })),
  on(TestCaseGeneratorActions.loadJiraStoriesSuccess, (state, { stories }) => ({
    ...state,
    jiraStories: jiraAdapter.setAll(stories, state.jiraStories),
    loading: false,
    error: null,
  })),
  on(TestCaseGeneratorActions.loadJiraStoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TestCaseGeneratorActions.deleteJiraStoriesSuccess, (state) => ({
    ...state,
    jiraStories: jiraAdapter.removeAll(state.jiraStories),
    loading: false,
    error: null,
  })),
  // Test Cases Generating
  on(TestCaseGeneratorActions.generateTestCases, (state) => ({
    ...state,
    generating: true,
    error: null,
  })),
  on(TestCaseGeneratorActions.generateTestCasesSuccess, (state, {versionId, testCases }) => ({
    ...state,
    testCases: testCaseAdapter.setAll(testCases, state.testCases),
    versionId,
    generating: false,
    error: null,
  })),
  on(TestCaseGeneratorActions.generateTestCasesProgressMessages, (state, { message }) => ({
    ...state,
    message,
  })),
  on(TestCaseGeneratorActions.generateTestCasesFailure, (state, { error }) => ({
    ...state,
    generating: false,
    error,
  })),
  // Update Test Case
  on(TestCaseGeneratorActions.updateTestCaseSuccess, (state, { testCase }) => ({
    ...state,
    testCases: testCaseAdapter.upsertOne(testCase, state.testCases),
    loading: false,
    error: null,
  })),
  on(TestCaseGeneratorActions.updateTestCaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Test Case Versions
  on(TestCaseGeneratorActions.loadTestCaseVersions, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TestCaseGeneratorActions.loadTestCaseVersionsSuccess, (state, { versions }) => ({
    ...state,
    testCaseVersions: testCaseVersionAdapter.setAll(versions, state.testCaseVersions),
    loading: false,
    error: null,
  })),
  on(TestCaseGeneratorActions.loadTestCaseVersionsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Test Cases by version ID
  on(TestCaseGeneratorActions.loadTestCaseDetailsByVersionId, (state) => ({
    ...state,
    loadingTestCases: true,
    error: null,
  })),
  on(TestCaseGeneratorActions.loadTestCaseDetailsByVersionIdSuccess, (state, { testCases }) => {
    // BPD (and some batches) reuse display testCaseId across hubs — ensure a unique entity id.
    const normalized = (testCases ?? []).map((tc: any, index: number) => ({
      ...tc,
      _id:
        tc?._id ??
        `${tc?.key || tc?.userStoryId || 'story'}__${tc?.testCaseId || 'tc'}__${index}`,
    }));
    return {
      ...state,
      testCasesByVersionId: testCaseByVersionIdAdapter.setAll(
        normalized,
        state.testCasesByVersionId
      ),
      loadingTestCases: false,
      error: null,
    };
  }),
  on(TestCaseGeneratorActions.loadTestCaseDetailsByVersionIdFailure, (state, { error }) => ({
    ...state,
    loadingTestCases: false,
    error,
  })),
  on(TestCaseGeneratorActions.clearTestCaseVersions, (state) => ({
    ...state,
    testCasesByVersionId: testCaseByVersionIdAdapter.getInitialState(),
    testCaseVersions: testCaseVersionAdapter.getInitialState(),
  }))
);
